// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__yfRMG","avatar_container":"Header_avatar_container__3BQTG","dropdown":"Header_dropdown__yv0Ok","avatar":"Header_avatar__1tnOh"};